/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { BadgeCheck, RotateCcw, ShieldCheck } from 'lucide-react';
import { chamarApi } from '@/nucleo/auth/cliente-api';
import { Button } from '@/ui/base/button';
import { Input } from '@/ui/base/input';
const NS = '/bff/v1/j08-s02-atestar-dupla-alcada';
export function AtestarDuplaAlcadaPage() {
  const [s, setS] = useState<any>();
  const [busy, setBusy] = useState(false);
  const [motivo, setMotivo] = useState('Revisão técnica solicitada antes do selo');
  async function call(path: string, body?: any) {
    setBusy(true);
    try {
      const e = await chamarApi<any>(NS + path, {
        metodo: path === '/state' ? 'GET' : 'POST',
        corpo: body,
      });
      setS(e.state);
    } finally {
      setBusy(false);
    }
  }
  useEffect(() => {
    void call('/state');
  }, []);
  if (!s)
    return (
      <main role="status" className="p-6">
        Carregando alçadas…
      </main>
    );
  const c = s.composicoes[0],
    aberta = c?.atestes.find((a: any) => a.estado === 'PRIMEIRA_ALCADA'),
    selada = c?.atestes.find((a: any) => a.estado === 'SELADA');
  const k = (v: string) => `j08-s02-${v}-${c.id}-${c.atestes.length + 1}`;
  return (
    <main className="min-w-0 max-w-[calc(100vw-2rem)] space-y-5 overflow-hidden">
      <header>
        <h1 className="text-3xl font-semibold">
          <ShieldCheck className="mr-2 inline h-7 w-7" />
          {s.titulo}
        </h1>
        <p>{s.descricao}</p>
        <p className="text-sm text-muted-foreground">
          Sessão: {s.sessao?.nome} · {s.sessao?.email}
        </p>
      </header>
      {s.alertas.map((a: any, i: number) => (
        <div role="alert" className="rounded-md border border-destructive p-3" key={i}>
          {a.mensagem} <span className="font-mono text-xs">{a.codigo}</span>
        </div>
      ))}
      {!c && (
        <p className="rounded-md border border-dashed p-6">
          Nenhuma composição calculada aguarda ateste.
        </p>
      )}
      {c && (
        <article className="space-y-4 rounded-md border p-4">
          <h2 className="font-semibold">
            {c.protocolo} · composição v{c.versao}
          </h2>
          <p className="break-all font-mono text-xs">Hash {c.hashReproducao}</p>
          <p>
            Bruto R$ {c.resultado.bruto} · retenções R$ {c.resultado.retencoes} · líquido R${' '}
            {c.resultado.liquido}
          </p>
          <div className="flex flex-wrap gap-2">
            <Button
              disabled={busy || !!aberta || !!selada}
              onClick={() =>
                void call('/verbs/atestar_primeira', {
                  composicaoId: c.id,
                  chaveIdempotencia: k('primeira'),
                })
              }
            >
              <BadgeCheck className="mr-2 h-4 w-4" />
              Atestar primeira alçada
            </Button>
            <Button
              disabled={busy || !aberta}
              onClick={() =>
                void call('/verbs/confirmar_segunda', {
                  composicaoId: c.id,
                  chaveIdempotencia: k('segunda'),
                })
              }
            >
              Confirmar segunda alçada
            </Button>
          </div>
          {aberta && (
            <section className="space-y-2 rounded-md bg-muted p-3">
              <p>
                Primeiro ateste: <strong>{aberta.primeiroAgenteNome}</strong> em{' '}
                {new Date(aberta.primeiroAtestadoEm).toLocaleString('pt-BR')}
              </p>
              <label htmlFor="motivo-reabertura" className="block text-sm">
                Motivo para reabrir
              </label>
              <Input
                id="motivo-reabertura"
                value={motivo}
                onChange={(e) => setMotivo(e.target.value)}
              />
              <Button
                variant="outline"
                disabled={busy || motivo.length < 8}
                onClick={() =>
                  void call('/verbs/revogar', {
                    composicaoId: c.id,
                    motivo,
                    chaveIdempotencia: k('revogar'),
                  })
                }
              >
                <RotateCcw className="mr-2 h-4 w-4" />
                Revogar antes do selo
              </Button>
            </section>
          )}
          {c.atestes.map((a: any) => (
            <section key={a.id} className="rounded-md border p-3">
              <h3 className="font-medium">
                Rodada {a.rodada} · {a.estado}
              </h3>
              <p>
                1ª: {a.primeiroAgenteNome} ·{' '}
                {new Date(a.primeiroAtestadoEm).toLocaleString('pt-BR')}
              </p>
              {a.segundoAgenteNome && (
                <p>
                  2ª: {a.segundoAgenteNome} ·{' '}
                  {new Date(a.segundoAtestadoEm).toLocaleString('pt-BR')}
                </p>
              )}
              {a.motivoRevogacao && (
                <p>
                  Revogada por {a.revogadoPorNome}: {a.motivoRevogacao}
                </p>
              )}
              <p className="text-xs">
                Versão {a.composicaoVersao} · hash {a.composicaoHash}
              </p>
            </section>
          ))}
        </article>
      )}
    </main>
  );
}
